
// Prevent the default paste and copy

export const preventAction = (e) => {
    e.preventDefault();
  }